import _extends from "@babel/runtime/helpers/extends";
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::15139b5f4236bc308adc0b1e9c84b98b>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconFacade } from '@atlaskit/icon/base';
var PageLiveDoc24Icon = function PageLiveDoc24Icon(props) {
  return /*#__PURE__*/React.createElement(IconFacade, _extends({
    dangerouslySetGlyph: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" role=\"presentation\"><path fill=\"#cd519d\" fill-rule=\"evenodd\" d=\"M24 3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3zM5.125 4.875h13.75l.153.01a1.125 1.125 0 0 1 0 2.23l-.153.01H5.125l-.153-.01a1.125 1.125 0 0 1 0-2.23zm5.25 6h-5.25l-.153.01a1.125 1.125 0 0 0 0 2.23l.153.01h5.25l.153-.01a1.125 1.125 0 0 0 0-2.23zm-.5 6h-4.75l-.153.01a1.125 1.125 0 0 0 0 2.23l.153.01h4.75l.153-.01a1.125 1.125 0 0 0 0-2.23zm7.029-7.564-4.28 6.073c-.317.473.012 1.116.57 1.116h2.988c.224 0 .389.215.337.438l-.665 3.182c-.178.766.807 1.218 1.242.569l4.28-6.073c.317-.473-.012-1.116-.57-1.116h-2.988a.353.353 0 0 1-.337-.438l.665-3.182c.178-.766-.808-1.218-1.242-.569\" clip-rule=\"evenodd\"/></svg>"
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
  }, props, {
    size: "medium"
  }));
};
PageLiveDoc24Icon.displayName = 'PageLiveDoc24Icon';

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default PageLiveDoc24Icon;